import { render, staticRenderFns } from "./customDashboardFilters.vue?vue&type=template&id=1a1620d1&scoped=true"
import script from "./customDashboardFilters.vue?vue&type=script&lang=js"
export * from "./customDashboardFilters.vue?vue&type=script&lang=js"
import style0 from "./customDashboardFilters.vue?vue&type=style&index=0&id=1a1620d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1620d1",
  null
  
)

export default component.exports